import { Box, styled, Typography } from "@mui/material";

export const StyledBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 512,
  background: theme.palette.custom.virtualSuccess,
  borderRadius: theme.borderRadius.radius.large,
  color: theme.palette.custom.white,
  outline: "none",
  padding: "23px 24px",

  [theme.breakpoints.down("md")]: {
    width: 430,
  },
  [theme.breakpoints.down("sm")]: {
    width: 350,
  },
  [theme.breakpoints.down("xs")]: {
    width: 270,
  },
}));

export const ModalHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderTopRightRadius: theme.borderRadius.radius.large,
  borderTopLeftRadius: theme.borderRadius.radius.large,
  marginBottom: "16px",
}));
export const StyledBoxFlex = styled(Box)(() => ({
  display: "flex",
  gap: "18px",
  alignItems: "center",
}));
export const StyledImg = styled("img")(() => ({
  cursor: "pointer",
}));
export const ModalTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.base.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
  color: theme.palette.custom.profileSuccess,
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.regular.fontSize,
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.mini.fontSize,
  },
}));
export const ModalDescription = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.small.fontSize,
  color: theme.palette.custom.profileSuccessDes,
  marginBottom: "20px",
  [theme.breakpoints.down("md")]: {
    fontSize: theme.typography.mini.fontSize,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.tiny.fontSize,
  },
}));
export const ButtonWrapper = styled(Typography)(() => ({
  paddingTop: "24px",
  display: "flex",
  justifyContent: "space-between",
}));
export const StyledTypographyVirtual = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.extraLarge.fontSize,
  color: theme.palette.custom.white,
  fontWeight: theme.typography.fontWeight.semiBold,
}));
export const StyledTypographyDes = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  color: theme.palette.custom.white,
}));
export const StyledTypographyLocker = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.small.fontSize,
  color: theme.palette.custom.virtualTitle,
  fontWeight: theme.typography.fontWeight.medium,
  marginBottom: "12px",
}));
export const StyledTypographyByTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  color: theme.palette.custom.virtualDescription,
  fontWeight: theme.typography.fontWeight.medium,
}));
export const CloseBtn = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.blackColor,
  cursor: "pointer",
  width: 38,
  height: 38,
}));

export const StyledLiTop = styled("li")(() => ({
  paddingTop: "20px",
}));
export const StyledTypographyTerms = styled(Typography)(({ theme }) => ({
  marginTop: "20px",
  fontSize: theme.typography.base.fontSize,
  color: theme.palette.custom.virtualDescription,
  fontWeight: theme.typography.fontWeight.medium,
}));
export const StyledTypographyLiTopic = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.base.fontSize,
  color: theme.palette.custom.virtualDescription,
}));
export const StyledTypographyCopy = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  color: theme.palette.custom.profileSuccess,
}));
export const StyledLockerIdTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.small.fontSize,
  color: theme.palette.custom.profileSuccess,
  fontWeight: theme.typography.fontWeight.medium,
  marginTop: "20px",
  marginBottom: "6px",
}));
export const StyledBoxInnerText = styled(Box)(({ theme }) => ({
  border: "1px solid #126ABC",
  padding: "12px",
  background: theme.palette.custom.white,
  overflow: "auto",
  maxHeight: 528,
  color: theme.palette.custom.virtualDescription,
}));
export const StyledBoxShow = styled(Box)(({ theme }) => ({
  background: theme.palette.custom.white,
  padding: "10px 14px",
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "32px",
}));
